if (!customElements.get("card-color-variants")) {
	customElements.define(
		"card-color-variants",
		class CardColorVariants extends HTMLElement {
			constructor() {
				super();
				this.init();
			}

			init() {
				this.swatches = this.querySelectorAll(".color-variant__swatch");
				this.productCard = this.closest(".card-wrapper");
				this.productImages = this.productCard.querySelectorAll(".card__media img");
				this.productLinks = this.productCard.querySelectorAll("a[href*='/products/']");

				// 元の画像を保存
				if (this.productImages.length > 0) {
					this.originalImages = [];
					this.productImages.forEach(img => {
						this.originalImages.push({
							src: img.src,
							srcset: img.srcset
						});
					});
				}

				if (this.swatches.length > 0) {
					this.setupEventListeners();
				}
			}

			setupEventListeners() {
				this.swatches.forEach((swatch) => {
					// 全てのスウォッチでイベントの伝播を止める
					swatch.addEventListener("click", (event) => {
						event.stopPropagation(); // 親要素（商品カード）へのイベント伝播を防ぐ
						
						if (swatch.tagName === 'A') {
							// <a>タグの場合はネイティブリンク動作を使用
							// event.preventDefault()は呼ばない
						} else {
							// <span>タグなどの場合はバリエーション切り替え
							event.preventDefault();
							const colorName = swatch.dataset.colorName;
							this.handleSwatchClick(colorName);
						}
					});

					// ホバー時に画像プレビュー
					swatch.addEventListener("mouseenter", (event) => {
						event.stopPropagation(); // ホバーイベントの伝播も防ぐ
						
						if (swatch.tagName === 'A') {
							const productId = swatch.dataset.productId;
							if (productId) {
								this.switchImageByProductId(productId);
							}
						} else {
							const colorName = swatch.dataset.colorName;
							if (colorName) {
								this.switchImage(colorName);
							}
						}
					});

					// ホバー解除時に元の画像に戻す
					swatch.addEventListener("mouseleave", (event) => {
						event.stopPropagation();
						this.restoreOriginalImage();
					});
				});
			}

			handleSwatchClick(colorName) {
				// 商品のバリエーション情報を取得
				const productData = this.getProductData();
				if (!productData || !productData.variants) return;

				// カラー名に対応するバリエーションを探す
				const selectedVariant = this.findVariantByColor(productData.variants, colorName);

				if (selectedVariant) {
					// バリエーションのURLを生成して遷移
					const variantUrl = `/products/${productData.handle}?variant=${selectedVariant.id}`;
					window.location.href = variantUrl;
				}
			}

			switchImage(colorName) {
				// 商品のバリエーション情報を取得
				const productData = this.getProductData();
				if (!productData || !productData.variants) return;

				// カラー名に対応するバリエーションを探す
				const selectedVariant = this.findVariantByColor(productData.variants, colorName);

				if (selectedVariant) {
					// バリエーションの画像があれば切り替え
					if (selectedVariant.featured_image) {
						this.updateProductImage(selectedVariant.featured_image);
					}
				}
			}

			findVariantByColor(variants, colorName) {
				// カラー名に対応するバリエーションを検索
				return variants.find((variant) => {
					return variant.option1 === colorName || 
						   variant.option2 === colorName || 
						   variant.option3 === colorName;
				});
			}

			getColorVariants(variants) {
				// カラーオプションを持つバリエーションをフィルタリング
				return variants.filter((variant) => {
					// option1, option2, option3のいずれかがカラー関連の場合
					const colorOptions = [variant.option1, variant.option2, variant.option3];
					return colorOptions.some(option => {
						if (!option) return false;
						const lowerOption = option.toLowerCase();
						return lowerOption.includes("color") ||
							lowerOption.includes("colour") ||
							lowerOption.includes("カラー") ||
							lowerOption.includes("色");
					});
				});
			}

			restoreOriginalImage() {
				// 元の画像を保存しておき、復元する
				if (!this.originalImages) {
					this.originalImages = [];
					this.productImages.forEach(img => {
						this.originalImages.push({
							src: img.src,
							srcset: img.srcset
						});
					});
				}

				this.productImages.forEach((img, index) => {
					if (this.originalImages[index]) {
						img.src = this.originalImages[index].src;
						img.srcset = this.originalImages[index].srcset;
					}
				});
			}

			switchImageByProductId(productId) {
				// メタフィールドベースの商品IDから画像を取得して切り替え
				const swatch = this.querySelector(`[data-product-id="${productId}"]`);
				if (swatch) {
					// 新しい方法：data属性から直接画像情報を取得
					const imageSrc = swatch.dataset.productImageSrc;
					const imageAlt = swatch.dataset.productImageAlt;
					
					if (imageSrc) {
						this.productImages.forEach((img) => {
							img.src = imageSrc;
							if (imageAlt) {
								img.alt = imageAlt;
							}
							
							// srcsetも更新
							const baseUrl = imageSrc.split('?')[0];
							img.srcset = `${baseUrl}?width=165 165w, ${baseUrl}?width=360 360w, ${baseUrl}?width=533 533w, ${baseUrl}?width=720 720w, ${baseUrl}?width=940 940w, ${baseUrl}?width=1066 1066w`;
						});
						return;
					}
					
					// フォールバック：従来の方法（style属性から画像URLを取得）
					if (swatch.style.getPropertyValue('--swatch--background')) {
						const backgroundValue = swatch.style.getPropertyValue('--swatch--background');
						const imageUrl = backgroundValue.match(/url\(['"]?([^'")]+)['"]?\)/);
						
						if (imageUrl && imageUrl[1]) {
							this.productImages.forEach((img) => {
								// より大きなサイズの画像URLを生成
								const largeImageUrl = imageUrl[1].replace(/width=\d+/, 'width=533');
								img.src = largeImageUrl;
								
								// srcsetも更新
								const baseUrl = largeImageUrl.split('?')[0];
								img.srcset = `${baseUrl}?width=165 165w, ${baseUrl}?width=360 360w, ${baseUrl}?width=533 533w, ${baseUrl}?width=720 720w, ${baseUrl}?width=940 940w, ${baseUrl}?width=1066 1066w`;
							});
						}
					}
				}
			}

			getProductData() {
				const productId = this.productCard.dataset.productId;
				if (!productId) return null;

				// 商品カード内のJSONデータを取得
				const productDataScript = this.productCard.querySelector(`.product-data-${productId}`);
				if (productDataScript) {
					try {
						return JSON.parse(productDataScript.textContent);
					} catch (error) {
						console.error("Error parsing product data:", error);
						return null;
					}
				}
				return null;
			}

			updateProductImage(imageData) {
				this.productImages.forEach((img) => {
					if (imageData && imageData.src) {
						// Shopifyの画像URLを生成
						const imageUrl = this.generateImageUrl(imageData.src);
						img.src = imageUrl;

						// srcsetも更新
						const srcset = this.generateSrcset(imageData.src);
						if (srcset) {
							img.srcset = srcset;
						}

						img.alt = imageData.alt || img.alt;
					}
				});
			}

			generateImageUrl(imageSrc) {
				// Shopifyの画像URLを適切なサイズで生成
				if (typeof imageSrc === "string") {
					// 既にShopifyの画像URLの場合はそのまま使用
					if (imageSrc.includes("cdn.shopify.com")) {
						return imageSrc;
					}
				}
				return imageSrc;
			}

			generateSrcset(imageSrc) {
				// レスポンシブ画像のsrcsetを生成
				if (typeof imageSrc === "string" && imageSrc.includes("cdn.shopify.com")) {
					const baseUrl = imageSrc.split("?")[0];
					return `${baseUrl}?width=165 165w, ${baseUrl}?width=360 360w, ${baseUrl}?width=533 533w, ${baseUrl}?width=720 720w, ${baseUrl}?width=940 940w, ${baseUrl}?width=1066 1066w`;
				}
				return null;
			}
		}
	);
}

// 商品カードのカラーバリエーション機能を初期化
document.addEventListener("DOMContentLoaded", () => {
	const colorVariants = document.querySelectorAll(".card__color-variants");
	colorVariants.forEach((variant) => {
		if (!variant.querySelector("card-color-variants")) {
			const wrapper = document.createElement("card-color-variants");
			wrapper.innerHTML = variant.innerHTML;
			variant.innerHTML = "";
			variant.appendChild(wrapper);
		}
	});
});
